import { forwardRef } from 'react';
import { QuickAdd, type QuickAddProps } from './QuickAdd';
import { useGoals, useProjects } from '@/lib/queries';

export const ProjectQuickAdd = forwardRef<HTMLInputElement, QuickAddProps>(
  function ProjectQuickAdd(props, ref) {
    const projects = useProjects();
    const goals = useGoals();
    return (
      <QuickAdd
        {...props}
        ref={ref}
        projectOptions={(projects.data ?? []).map((project) => {
          const goal = goals.data?.find((goal) => goal.id === project.goalId);
          return {
            id: project.id,
            label: goal ? `${goal.title} → ${project.title}` : project.title,
          };
        })}
        projectsLoading={projects.isPending || goals.isPending}
        projectsError={projects.isError || goals.isError}
        retryProjects={() => {
          void projects.refetch();
          void goals.refetch();
        }}
      />
    );
  },
);
